// extracted by mini-css-extract-plugin
export default {"tooltip":"dq-z","sharingV2":"eq-z","sharingIconsV2":"fq-z","links":"gq-z","link":"hq-z","facebookV2":"iq-z","twitterV2":"jq-z","pinterestV2":"kq-z"};